import "./Articles.module.css";
import Header from "@/reusable_sections/Header";
import FullArchive from "./sections/FullArchive";
import Footer from "@/reusable_sections/Footer";
export default function ArticlesPage() {
  return <div>
      <Header />
      <FullArchive />
      <Footer />
    </div>;
}